export default "__VITE_ASSET__d8d7accd__"